import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import type { TCity } from "@/types"
import { cityName, getFlagEmoji, peopleURL } from "@/utils"
import { CityFilter } from "../../controls"
import { TagBox } from "./TagBox"

export function CityTag({ city }: { city: TCity }) {
  const { t, i18n } = useTranslation()
  const locale = i18n.language

  return (
    <TagBox
      tooltip={t("City")}
      href={`${peopleURL}?${CityFilter.filterName}=${city.id}`}
      leftSection={<Text>{getFlagEmoji(city.country_code)}</Text>}
    >
      {cityName(city, locale)}
    </TagBox>
  )
}
